import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 18h5l7 -10h6","key":"svg-1"}]]

const IconTrendingUp2 = createReactComponent('outline', 'trending-up-2', 'TrendingUp2', __iconNode);

export default IconTrendingUp2;